const GET_COST_CENTER = 'GET_COST_CENTER';
const SET_COST_CENTER = 'SET_COST_CENTER';

export
{
    GET_COST_CENTER,
    SET_COST_CENTER
};
